import React from "react"
import { CheckIcon } from "../../../views/questionnaire/QuestionnaireTable"
import { Tab, Tabs } from "@mui/material"
import MergeField from "./MergeField"
import { store } from "../../../../stores/Store"
import { observer } from "mobx-react-lite"
import { sortKeys } from "./mergeUtils"


interface MergeReviewProps {
    dataSources: any[];
}


const otherPeoplePrefixes = ["subject_supporter", "subject_partner", "subject_mother", "subject_father", "subject_first_parent", "subject_second_parent", "subject_first_guardian", "subject_second_guardian", "subject_child"]


export default observer(function MergeReview ({dataSources}: MergeReviewProps) {

    var keys = []
    dataSources.forEach((answers) => {
        Object.keys(answers).forEach(fieldName => {
            if (!keys.includes(fieldName)) {
                keys.push(fieldName)
            }
        })
    })
    keys = sortKeys(keys)

    console.log(dataSources)

    var keysWithConflicts = keys.filter(fieldName => {
        var relevantDataSources = dataSources.filter(answers => Object.keys(answers).includes(fieldName))
        if (relevantDataSources.length <= 1) {
            return false
        }

        var firstValue = relevantDataSources[0][fieldName]
        var conflictingDataSources = relevantDataSources.filter(answers => {
            var numberRegex = /^([0-9]*)\.{0,1}([0-9]*)$/
            if (numberRegex.test(firstValue)) {
                if (numberRegex.test(answers[fieldName])) {
                    console.log("Comparing conflicting numbers", firstValue, answers[fieldName])
                    return parseFloat(firstValue) !== parseFloat(answers[fieldName])
                }
            }
            return firstValue !== answers[fieldName]
        })

        return conflictingDataSources.length > 0
    })
    keysWithConflicts = sortKeys(keysWithConflicts)

    const [tab, setTab] = React.useState<"subject"|"other_people"|"position"|"account"|"misc"|"conflicts">(keysWithConflicts.length ? "conflicts" : "subject")

    const subject =       keys.filter(key => !otherPeoplePrefixes.find(opp => key.startsWith(opp)) && key.startsWith("subject"))
    const other_people =  keys.filter(key => !!otherPeoplePrefixes.find(opp => key.startsWith(opp)))
    const position =      keys.filter(key => key.startsWith("job") || key.startsWith("course") || key.startsWith("cos") || key.startsWith("cas"))
    const account =       keys.filter(key => key.startsWith("account") || key.startsWith("sponsor"))
    const misc =          keys.filter(key => !key.startsWith("subject") && !key.startsWith("sponsor") && !key.startsWith("account") && !key.startsWith("job") && !key.startsWith("cos") && !key.startsWith("cas") && !key.startsWith("course"))

    return (
        <div>
            <div style={{margin: "15px 0"}}>
                {[...dataSources, ...store.QuestionnaireStore.mergedDependants].length > 1 ? (
                    <p>You have merged {dataSources.length} data sources.</p>
                ) : null}

                {[...dataSources, ...store.QuestionnaireStore.mergedDependants].filter(source => "iconId" in source).map((source, i) => (
                    <div key={i} style={{display: "flex", gap: "8px", alignItems: "center", margin: "5px 0 5px 20px"}}>
                        <CheckIcon index={source.iconId} />
                        <small>{source.label}</small>
                    </div>
                ))}

                {keysWithConflicts.length > 1 ? (
                    <p>There are {keysWithConflicts.length} conflicts among your data sources, please view each conflict and make sure the right value is being used. </p>
                ) : null}

                {keysWithConflicts.length === 1 ? (
                    <p>There is a conflict among your data sources, please view each conflict and make sure the right value is being used. </p>
                ) : null}
            </div>

            <Tabs
                value={tab}
                textColor="primary"
                indicatorColor="primary"
                scrollButtons={true}
                visibleScrollbar={true}>
                {keysWithConflicts.length ? (
                    <Tab hidden onClick={() => setTab("conflicts")} value="conflicts" label={<>Conflicts {keysWithConflicts.length}</>} />
                ) : null}

                {subject?.length ? (
                    <Tab onClick={() => setTab("subject")}      value="subject" label={<>Applicant</>} />
                ) : null}

                {other_people?.length ? (
                    <Tab onClick={() => setTab("other_people")} value="other_people" label={<>Related persons</>} />
                ) : null}

                {position?.length ? (
                    <Tab onClick={() => setTab("position")}     value="position" label={position.find(key => key.startsWith("job")) ? "Job" : "Course"} />
                ) : null}

                {account?.length ? (
                    <Tab onClick={() => setTab("account")}      value="account" label={<>Adviser & Sponsor</>} />
                ) : null}

                {misc?.length ? (
                    <Tab onClick={() => setTab("misc")}         value="misc" label={<>Miscellaneous</>} />
                ) : null}
            </Tabs>

            <div style={{maxHeight: "400px", overflowY: "auto", borderBottom: "2px solid #d4d4d4", background: "whitesmoke"}}>
                {tab === "conflicts" ? (
                    keysWithConflicts.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} showConflict={true} />)
                ) : null}

                {tab === "subject" ? (
                    subject.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} />)
                ) : null}

                {tab === "other_people" ? (
                    other_people.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} />)
                ) : null}

                {tab === "position" ? (
                    position.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} />)
                ) : null}

                {tab === "account" ? (
                    account.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} />)
                ) : null}

                {tab === "misc" ? (
                    misc.map((fieldKey, i) => <MergeField key={i} dataSources={dataSources} fieldKey={fieldKey} />)
                ) : null}
            </div>
        </div>
    )
})